import React, { useState, useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { appConfig } from '../config';
import { ttsSpeak } from '../services/apiService';
import './GlobalChatWidget.css';
import SuggestionChips from './SuggestionChips';

const HEJVI_LOGO = 'data:image/png;base64,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';


// ─── Token helper ────────────────────────────────────────────────────
const getAuthToken = () => {
  const LS_KEYS = ['hejvi_access_token','token','access_token','jwt_token','hejvi_token','authToken'];
  for (const key of LS_KEYS) {
    const val = localStorage.getItem(key);
    if (val && val !== 'null' && val !== 'undefined' && val.length > 20) return val;
  }
  return null;
};

const generateSessionId = () =>
  'gsess_' + Date.now().toString(36) + Math.random().toString(36).slice(2);

// ─── Typing indicator ───────────────────────────────────────────────
const TypingDots = () => (
  <div className="gcw-typing"><span /><span /><span /></div>
);

// ─── Lightbox Modal ─────────────────────────────────────────────────
const ImageModal = ({ image, onClose }) => {
  const label = image.caption || image.description || null;

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return createPortal(
    <div
      className="gcw-lightbox-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Bildvorschau"
    >
      <div className="gcw-lightbox-content" onClick={e => e.stopPropagation()}>
        <button className="gcw-lightbox-close" onClick={onClose} aria-label="Schließen">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        </button>
        <img
          src={image.image_url}
          alt={label || 'Abbildung'}
          className="gcw-lightbox-img"
        />
        {label && (
          <div className="gcw-lightbox-caption">
            {image.caption && (
              <span className="gcw-lightbox-caption-badge">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                </svg>
                Beschriftung aus Dokument
              </span>
            )}
            <p>{label}</p>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

// ─── Einzelne Bild-Karte (klickbar → Lightbox) ──────────────────────
const ImageCard = ({ image, index, onOpenModal }) => {
  const [loaded, setLoaded] = useState(false);
  const [error,  setError]  = useState(false);

  const caption     = image.caption     || null;
  const description = image.description || null;
  const label       = caption || description || null;

  if (error) {
    return (
      <div className="gcw-image-card gcw-image-card--error">
        ⚠️ Bild nicht ladbar
      </div>
    );
  }

  return (
    <div
      className="gcw-image-card gcw-image-card--clickable"
      onClick={() => onOpenModal && onOpenModal(image)}
      title="Klicken zum Vergrößern"
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && onOpenModal && onOpenModal(image)}
    >
      <div className={`gcw-image-wrapper ${loaded ? 'gcw-image-wrapper--loaded' : ''}`}>
        {!loaded && <div className="gcw-image-skeleton" />}
        <img
          src={image.image_url}
          alt={label || `Abbildung ${index + 1}`}
          className="gcw-image-img"
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
        />
        <span className="gcw-image-badge">{index + 1}</span>
        <div className="gcw-image-zoom-hint">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
            <circle cx="11" cy="11" r="7"/>
            <path d="M21 21l-4.35-4.35" strokeLinecap="round"/>
            <path d="M11 8v6M8 11h6" strokeLinecap="round"/>
          </svg>
        </div>
      </div>
      {label && (
        <div className="gcw-image-label">
          {caption && (
            <span className="gcw-image-caption-badge">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
              </svg>
              Beschriftung
            </span>
          )}
          <p className="gcw-image-desc">{label}</p>
        </div>
      )}
    </div>
  );
};

// ─── Antworttext mit [IMG:ID]-Markern inline rendern ─────────────────
//
// Das LLM bettet [IMG:42] direkt hinter dem zugehörigen Schritt ein.
// Diese Funktion parst den Text und rendert Bilder an der richtigen Stelle.
// Bilder ohne Inline-Marker kommen als kleines Grid ans Ende.
const renderAnswerWithImages = (text, images, onOpenModal) => {
  if (!images || images.length === 0) {
    return <p className="gcw-text">{text}</p>;
  }

  const imageMap = {};
  images.forEach(img => { imageMap[img.id] = img; });

  const IMG_RE = /\[IMG:(\d+)\]/g;
  const parts = [];
  let last = 0;
  let match;
  const inlineImageIds = new Set();

  while ((match = IMG_RE.exec(text)) !== null) {
    const id = parseInt(match[1], 10);
    if (last < match.index) {
      parts.push({ type: 'text', content: text.slice(last, match.index) });
    }
    parts.push({ type: 'image', id });
    inlineImageIds.add(id);
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    parts.push({ type: 'text', content: text.slice(last) });
  }

  // Keine Inline-Marker im Text → Bilder als Grid unter dem Text
  if (inlineImageIds.size === 0) {
    return (
      <div className="gcw-answer-body">
        <p className="gcw-text">{text}</p>
        <div className="gcw-image-grid gcw-image-grid--remaining">
          {images.map((img, i) => (
            <ImageCard key={img.id || i} image={img} index={i} onOpenModal={onOpenModal} />
          ))}
        </div>
      </div>
    );
  }

  const remainingImages = images.filter(img => !inlineImageIds.has(img.id));
  let imgCounter = 0;

  const elements = parts.map((part, i) => {
    if (part.type === 'text') {
      const trimmed = part.content.trim();
      if (!trimmed) return null;
      return <p key={`t${i}`} className="gcw-text gcw-text--inline">{part.content}</p>;
    }
    const img = imageMap[part.id];
    if (!img) return null;
    imgCounter++;
    return (
      <div key={`img${i}`} className="gcw-inline-image">
        <ImageCard image={img} index={imgCounter - 1} onOpenModal={onOpenModal} />
      </div>
    );
  }).filter(Boolean);

  return (
    <div className="gcw-answer-body">
      {elements}
      {remainingImages.length > 0 && (
        <div className="gcw-image-grid gcw-image-grid--remaining">
          {remainingImages.map((img, i) => (
            <ImageCard key={img.id || i} image={img} index={imgCounter + i} onOpenModal={onOpenModal} />
          ))}
        </div>
      )}
    </div>
  );
};

// ─── Source card with navigation ────────────────────────────────────
const SourceCard = ({ source, index, onNavigate, t }) => {
  const [excerptExpanded, setExcerptExpanded] = useState(false);

  const isVideo   = source.source_type === 'video_transcript';
  const isQuiz    = source.source_type === 'quiz';
  const isCourse  = source.source_type === 'course';
  const typeLabel = isVideo ? '▶ Video' : isQuiz ? '✦ Quiz' : isCourse ? '◈ Kurs' : '📄 Dokument';

  const excerpt    = source.excerpt || source.chunk_text || '';
  const hasExcerpt = excerpt.trim().length > 0;
  const LIMIT      = 260;
  const isLong     = excerpt.length > LIMIT;
  const displayExcerpt = (!excerptExpanded && isLong) ? excerpt.slice(0, LIMIT) + '…' : excerpt;

  return (
    <div className="gcw-source-card">
      <div className="gcw-source-header">
        <span className="gcw-source-type-badge">{typeLabel}</span>
        {source.section_heading && (
          <span className="gcw-source-heading">{source.section_heading}</span>
        )}
      </div>
      <p className="gcw-source-name">{source.source_name || source.element_name || '?'}</p>
      {hasExcerpt && (
        <div className="gcw-source-excerpt">
          <p>{displayExcerpt}</p>
          {isLong && (
            <button className="gcw-excerpt-toggle" onClick={() => setExcerptExpanded(e => !e)}>
              {excerptExpanded ? 'Weniger anzeigen' : 'Vollständig anzeigen'}
              <span className={`gcw-chevron ${excerptExpanded ? 'gcw-chevron--up' : ''}`} style={{fontSize:10}}>▾</span>
            </button>
          )}
        </div>
      )}
      {source.deep_link && !((source.source_name || '').match(/^qa_/i)) && (
        <button className="gcw-source-link" onClick={() => onNavigate(source.deep_link, isVideo)}>
          {isVideo ? (t('watchVideo') || 'Video ansehen') : (t('notif_open_document') || 'Dokument öffnen')}
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"/>
          </svg>
        </button>
      )}
    </div>
  );
};

// ─── Main component ─────────────────────────────────────────────────
const GlobalChatWidget = ({ isOpen, onClose, initialMessage = null, restoreFromSession = false }) => {
  const { t, currentLanguage } = useLanguage();
  const { makeAuthenticatedRequest, logout } = useAuth();
  const navigate = useNavigate();
  const lang = (currentLanguage ? String(currentLanguage).split('-')[0].toLowerCase() : 'de');

  const [messages,        setMessages]        = useState([]);
  const [input,           setInput]           = useState('');
  const [isLoading,       setIsLoading]       = useState(false);
  const [sessionId]                           = useState(generateSessionId);
  const [expandedSources, setExpandedSources] = useState({});
  const [ragSuggestions,  setRagSuggestions]  = useState([]);
  const [ragLastLinks,    setRagLastLinks]    = useState([]);
  const [voiceMode,       setVoiceMode]       = useState(false);
  const [isSpeaking,      setIsSpeaking]      = useState(false);
  const [modalImage,      setModalImage]      = useState(null);
  const [dynamicSuggestions, setDynamicSuggestions] = useState(null);
  // null  = noch nicht geladen
  // []    = Ladevorgang läuft / fehlgeschlagen → static fallback zeigen
  // [...] = erfolgreich geladen → dynamische Fragen zeigen

  const endRef   = useRef(null);
  const inputRef = useRef(null);
  const histRef  = useRef([]);
  const audioRef = useRef(null);

  useEffect(() => {
    window.__hejviChatHistory__ = histRef;
    return () => { window.__hejviChatHistory__ = null; };
  }, []);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // ── Auto-Save: Chatverlauf persistent halten ─────────────────────────────
  // Speichert bei jeder Nachrichtenänderung in sessionStorage (separater Key
  // von hejvi_chat_state, der nur für die Element-Navigate-Restore-Kette genutzt wird).
  // Wird beim Öffnen des Modals wiederhergestellt wenn der Chat leer ist.
  useEffect(() => {
    if (messages.length <= 1) return; // Nur Begrüßung oder leer → nichts speichern
    try {
      sessionStorage.setItem('hejvi_chat_persistent', JSON.stringify({
        messages,
        history:       histRef.current,
        ragSuggestions,
        ragLastLinks,
      }));
    } catch (_) {}
  }, [messages, ragSuggestions, ragLastLinks]);

  useEffect(() => {
    if (!isOpen) return;
    setTimeout(() => inputRef.current?.focus(), 100);

    // ── Chat-Wiederherstellung nach Rückkehr von einer ElementPage ───────────
    if (restoreFromSession) {
      try {
        const saved = sessionStorage.getItem('hejvi_chat_state');
        if (saved) {
          const { messages: savedMsgs, history, ragSuggestions: savedSug, ragLastLinks: savedLinks } = JSON.parse(saved);
          if (Array.isArray(savedMsgs) && savedMsgs.length > 0) {
            setMessages(savedMsgs);
            histRef.current   = history || [];
            setRagSuggestions(savedSug  || []);
            setRagLastLinks(savedLinks  || []);
            sessionStorage.removeItem('hejvi_chat_state');
            return; // Keine Begrüßung anzeigen — Verlauf ist wiederhergestellt
          }
        }
      } catch (_) {}
    }

    // ── Auto-Restore: Verlauf nach Navigation zu anderen App-Bereichen ────────
    // Greift wenn GlobalChatWidget neu gemountet wurde (Dashboard unmount/remount)
    // und der Chat noch leer ist.
    if (messages.length === 0) {
      try {
        const persisted = sessionStorage.getItem('hejvi_chat_persistent');
        if (persisted) {
          const { messages: savedMsgs, history, ragSuggestions: savedSug, ragLastLinks: savedLinks } = JSON.parse(persisted);
          if (Array.isArray(savedMsgs) && savedMsgs.length > 1) {
            setMessages(savedMsgs);
            histRef.current   = history || [];
            setRagSuggestions(savedSug  || []);
            setRagLastLinks(savedLinks  || []);
            return; // Verlauf wiederhergestellt — kein Greeting nötig
          }
        }
      } catch (_) {}
    }

    if (initialMessage?.question && initialMessage?.answer) {
      const userMsg = { role: 'user', content: initialMessage.question, sources: [], images: [], fromVoice: true };
      const assistantMsg = {
        role: 'assistant', content: initialMessage.answer,
        sources: initialMessage.sources || [], is_rag: true,
        fromVoice: true, images: initialMessage.images || [],
      };
      setMessages(prev => {
        if (prev.length === 0) {
          return [
            { role: 'assistant', content: t('globalChatGreeting') || 'Hej! Ich kann dir übergreifend über alle deine Dokumente und Videos helfen. Was möchtest du wissen?', sources: [], images: [] },
            userMsg, assistantMsg,
          ];
        }
        return [...prev, userMsg, assistantMsg];
      });
      histRef.current = [
        ...histRef.current,
        { role: 'user', content: initialMessage.question },
        { role: 'assistant', content: initialMessage.answer },
      ].slice(-12);
    } else if (messages.length === 0) {
      setMessages([{
        role: 'assistant',
        content: t('globalChatGreeting') || 'Hej! Ich kann dir übergreifend über alle deine Dokumente und Videos helfen. Was möchtest du wissen?',
        sources: [], images: [],
      }]);
    }
  }, [isOpen, initialMessage]); // eslint-disable-line react-hooks/exhaustive-deps

  // Speichert den aktuellen Chat-Zustand in sessionStorage bevor zur ElementPage navigiert wird.
  // Dashboard liest ihn beim Zurück-navigieren wieder ein (restoreFromSession-Prop).
  const saveChatState = () => {
    if (messages.length <= 1) return; // Nur Begrüßung → nichts sichern
    try {
      sessionStorage.setItem('hejvi_chat_state', JSON.stringify({
        messages,
        history:       histRef.current,
        ragSuggestions,
        ragLastLinks,
      }));
    } catch (_) {}
  };

  const navigate_to = (deepLink, isVideo) => {
    if (!deepLink) return;
    saveChatState();
    onClose();
    // deep_link ist eine absolute URL (z.B. https://app.hejvi.de/element/abc123).
    // Pfad extrahieren damit React Router intern navigiert (kein full reload).
    try {
      const url = new URL(deepLink);
      navigate(url.pathname, { state: { sourcePage: '/dashboard', openChatOnReturn: true } });
    } catch {
      navigate(deepLink, { state: { sourcePage: '/dashboard', openChatOnReturn: true } });
    }
  };

  const stopSpeaking = () => {
    if (audioRef.current) { audioRef.current.pause(); audioRef.current = null; }
    setIsSpeaking(false);
  };

  const speakText = async (text) => {
    stopSpeaking();
    try {
      setIsSpeaking(true);
      const audio = await ttsSpeak(text, lang);
      audioRef.current = audio;
      audio.addEventListener('ended',  () => setIsSpeaking(false), { once: true });
      audio.addEventListener('error',  () => setIsSpeaking(false), { once: true });
      audio.play();
    } catch (err) {
      console.error('[GlobalChat TTS]', err);
      setIsSpeaking(false);
    }
  };

  useEffect(() => { if (!isOpen) stopSpeaking(); }, [isOpen]);
  useEffect(() => { if (!isOpen) setModalImage(null); }, [isOpen]);

  // ── Dynamische Musterfragen: Fetch beim ersten Öffnen ────────────────────
  // Sampelt chunk_themes aus der eigenen Wissensbasis und generiert daraus
  // 3 konkrete Fragen per GPT-4o-mini. Gecacht in sessionStorage pro Sprache.
  useEffect(() => {
    if (!isOpen) return;
    if (messages.length > 1) return;       // Nur bei leerem / Begrüßungs-Chat
    if (dynamicSuggestions !== null) return; // Bereits geladen oder in Bearbeitung

    const cacheKey = `hejvi_chat_suggestions_${lang}`;

    // sessionStorage-Cache prüfen (überlebt Widget-Schließen/Öffnen)
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed) && parsed.length >= 2) {
          setDynamicSuggestions(parsed);
          return;
        }
      }
    } catch (_) {}

    // makeAuthenticatedRequest kennt die korrekte API-Base-URL und sendet immer GET —
    // deshalb eigener GET-Endpunkt /document-chat-suggestions statt POST-Hack.
    setDynamicSuggestions([]);

    makeAuthenticatedRequest(`/document-chat-suggestions?language=${lang}`)
      .then(res => res.json())
      .then(data => {
        const sugs = data?.suggestions;
        if (Array.isArray(sugs) && sugs.length >= 2) {
          setDynamicSuggestions(sugs);
          try { sessionStorage.setItem(cacheKey, JSON.stringify(sugs)); } catch (_) {}
        } else {
          setDynamicSuggestions(null);
        }
      })
      .catch(() => setDynamicSuggestions(null));
  }, [isOpen, messages.length]); // eslint-disable-line react-hooks/exhaustive-deps

  // displayOverride: optionaler Anzeigetext für die User-Bubble (z.B. bei suggest_similar-Chips,
  // wo s.label als lesbarer Text angezeigt wird, aber s.query ans Backend geht).
  const sendMessage = useCallback(async (text = input, displayOverride = null) => {
    const rawQuestion = text.trim();
    if (!rawQuestion || isLoading) return;

    // __COLLEAGUE_NEEDED__: Prefix vom ask_colleague-Chip — sauber anzeigen,
    // aber vollständigen Text (mit Prefix) an die API senden damit das Backend
    // direkt zu saveUnansweredQuestion() routen kann.
    const displayQuestion = displayOverride
      || (rawQuestion.startsWith('__COLLEAGUE_NEEDED__:')
        ? rawQuestion.slice('__COLLEAGUE_NEEDED__:'.length).trim()
        : rawQuestion);
    const question = rawQuestion;

    stopSpeaking();
    setRagSuggestions([]);
    setRagLastLinks([]);
    setInput('');
    setMessages(prev => [...prev, { role: 'user', content: displayQuestion, sources: [], images: [] }]);
    setIsLoading(true);

    try {
      const data = await makeAuthenticatedRequest('/document-chat', {
        method: 'POST',
        body: JSON.stringify({ question, session_id: sessionId, history: histRef.current, language: lang }),
      }).then(res => res.json());

      const assistantMsg = {
        role:        'assistant',
        content:     data.answer || t('chatErrorNoAnswer') || 'Keine Antwort erhalten.',
        sources:     data.sources     || [],
        links:       data.links       || [],
        device:      data.device      || null,
        device_type: data.device_type || null,
        is_rag:      data.is_rag,
        images:      data.images      || [],
      };

      console.log('[HejVi RAG] images:', data.images?.length, 'is_rag:', data.is_rag);

      setMessages(prev => [...prev, assistantMsg]);
      setRagSuggestions(data.suggestions || []);
      setRagLastLinks(data.links || []);
      histRef.current = [
        ...histRef.current,
        { role: 'user',      content: displayQuestion },
        { role: 'assistant', content: assistantMsg.content },
      ].slice(-12);

      if (voiceMode && assistantMsg.content) speakText(assistantMsg.content);

    } catch (err) {
      const msg = err?.message || '';
      if (msg.includes('Authentication failed') || msg.includes('No access token')) {
        onClose?.(); navigate('/login'); return;
      }
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: t('chatErrorGeneric') || 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
        sources: [], images: [],
      }]);
    } finally {
      setIsLoading(false);
    }
  }, [input, isLoading, sessionId, lang, t, makeAuthenticatedRequest, navigate, onClose]);

  const handleKeyDown = (e) => {
    e.stopPropagation();
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  };

  const clearChat = () => {
    sessionStorage.removeItem('hejvi_chat_persistent');
    sessionStorage.removeItem('hejvi_chat_state');
    setMessages([]); histRef.current = [];
    setRagSuggestions([]); setRagLastLinks([]);
    setExpandedSources({}); setModalImage(null);
  };

  const toggleSources = (idx) =>
    setExpandedSources(prev => ({ ...prev, [idx]: !prev[idx] }));

  // Dynamische Fragen bevorzugen, statische als Fallback wenn noch nicht geladen
  // oder Wissensbasis leer ist.
  const effectiveSuggestions = (Array.isArray(dynamicSuggestions) && dynamicSuggestions.length >= 2)
    ? dynamicSuggestions
    : [
        t('globalSuggestion1') || 'Was enthalten meine Dokumente zu Sicherheitsanforderungen?',
        t('globalSuggestion2') || 'Fasse alle verfügbaren Inhalte zusammen',
        t('globalSuggestion3') || 'Welche Videos behandeln dieses Thema?',
      ];

  if (!isOpen) return null;

  return createPortal(
    <>
      {modalImage && <ImageModal image={modalImage} onClose={() => setModalImage(null)} />}

      <div className="gcw-overlay" role="dialog" aria-modal="true" aria-label={t('globalChatTitle') || 'Knowledge Assistant'}>
        <div className="gcw-modal">

          {/* Header */}
          <div className="gcw-header">
            <div className="gcw-header-info">
              <div className="gcw-logo"><span className="gcw-logo-text">HejVi</span></div>
              <div>
                <h2 className="gcw-title">{t('globalChatTitle') || 'Knowledge Assistant'}</h2>
                <span className="gcw-subtitle">{t('globalChatSubtitle') || 'Alle Dokumente & Videos'}</span>
              </div>
            </div>
            <div className="gcw-header-actions">
              {isSpeaking && (
                <button className="gcw-btn-icon gcw-stop-speaking" onClick={stopSpeaking} title={t('stopSpeaking') || 'Sprachausgabe stoppen'}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <rect x="4" y="4" width="16" height="16" rx="2"/>
                  </svg>
                </button>
              )}
              <button
                className={`gcw-btn-icon gcw-voice-toggle ${voiceMode ? 'gcw-voice-toggle--on' : ''}`}
                onClick={() => { setVoiceMode(v => !v); if (voiceMode) stopSpeaking(); }}
                title={voiceMode ? (t('voiceModeOff') || 'Sprachausgabe deaktivieren') : (t('voiceModeOn') || 'Sprachausgabe aktivieren')}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  {voiceMode ? (
                    <>
                      <path d="M11 5L6 9H2v6h4l5 4V5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                      <path d="M15.54 8.46a5 5 0 0 1 0 7.07" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </>
                  ) : (
                    <>
                      <path d="M11 5L6 9H2v6h4l5 4V5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                      <line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      <line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </>
                  )}
                </svg>
                {isSpeaking && <span className="gcw-speaking-dot" />}
              </button>
              <button className="gcw-btn-icon" onClick={clearChat} title={t('chatClear') || 'Chat leeren'}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M3 6h18M8 6V4h8v2M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
              <button className="gcw-btn-icon gcw-close" onClick={onClose} title={t('close') || 'Schließen'}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Messages */}
          <div className="gcw-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`gcw-msg gcw-msg--${msg.role}`}>
                {msg.role === 'assistant' && (
                  <div className="gcw-avatar"><span className="gcw-logo-text">HejVi</span></div>
                )}
                <div className="gcw-bubble">
                  {msg.fromVoice && (
                    <span className="gcw-voice-origin-badge">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" style={{display:'inline',verticalAlign:'middle',marginRight:4}}>
                        <path d="M12 1A3 3 0 0 0 9 4V10A3 3 0 0 0 12 13A3 3 0 0 0 15 10V4A3 3 0 0 0 12 1Z" stroke="currentColor" strokeWidth="2"/>
                        <path d="M19 10V13A7 7 0 0 1 5 13V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M12 19V23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                      Spracheingabe
                    </span>
                  )}

                  {/* Antworttext — mit Bildern inline wenn vorhanden */}
                  {msg.role === 'assistant' && msg.images?.length > 0
                    ? renderAnswerWithImages(msg.content, msg.images, setModalImage)
                    : <p className="gcw-text">{msg.content}</p>
                  }

                  {/* Device-Badge */}
                  {msg.role === 'assistant' && msg.is_rag && msg.device && (
                    <div className="gcw-context-banner">
                      <div className="gcw-device-row">
                        <span className={`gcw-device-badge gcw-device-badge--${msg.device_type || 'other'}`}>
                          {msg.device_type === 'machine' ? '⚙️' : msg.device_type === 'tool' ? '🔧' : msg.device_type === 'material' ? '🧱' : msg.device_type === 'software' ? '💻' : '🔩'}
                          {' '}{msg.device}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Quellen */}
                  {msg.role === 'assistant' && msg.is_rag && msg.sources?.length > 0 && (
                    <div className="gcw-sources-wrapper">
                      <button className="gcw-sources-toggle" onClick={() => toggleSources(idx)}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                          <polyline points="14 2 14 8 20 8"/>
                        </svg>
                        {t('sourcesUsed') || 'Quellen'} ({msg.sources.length})
                        <span className={`gcw-chevron ${expandedSources[idx] ? 'gcw-chevron--up' : ''}`}>▾</span>
                      </button>
                      {expandedSources[idx] && (
                        <div className="gcw-sources-list">
                          {msg.sources.map((src, si) => (
                            <SourceCard key={si} index={si} source={src} onNavigate={navigate_to} t={t} />
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* SuggestionChips */}
                  {msg.role === 'assistant' && idx === messages.length - 1 && !isLoading && ragSuggestions.length > 0 && (
                    <SuggestionChips
                      suggestions={ragSuggestions}
                      links={ragLastLinks}
                      language={lang}
                      onQuestion={(label, display) => sendMessage(label, display)}
                      onNavigate={(url) => {
                        const path = url.replace(window.location.origin, '').replace(/^https?:\/\/[^/]+/, '');
                        saveChatState();
                        onClose();
                        navigate(path, { state: { sourcePage: '/dashboard', openChatOnReturn: true } });
                      }}
                    />
                  )}
                </div>
              </div>
            ))}

            {isLoading && (
              <div className="gcw-msg gcw-msg--assistant">
                <div className="gcw-avatar"><span className="gcw-logo-text">HejVi</span></div>
                <div className="gcw-bubble"><TypingDots /></div>
              </div>
            )}
            <div ref={endRef} />
          </div>

          {/* Quick suggestions */}
          {messages.length <= 1 && (
            <div className="gcw-suggestions">
              {effectiveSuggestions.map((s, i) => (
                <button key={i} className="gcw-suggestion" onClick={() => sendMessage(s)}>{s}</button>
              ))}
            </div>
          )}

          {/* Input */}
          <div className="gcw-input-row">
            <textarea
              ref={inputRef}
              className="gcw-input"
              placeholder={t('globalChatPlaceholder') || 'Stelle eine Frage über alle deine Inhalte …'}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              rows={1}
              disabled={isLoading}
            />
            <button
              className="gcw-send"
              onClick={() => sendMessage()}
              disabled={!input.trim() || isLoading}
              aria-label={t('send') || 'Senden'}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M22 2L11 13M22 2L15 22 11 13 2 9l20-7z"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

        </div>
      </div>
    </>,
    document.body
  );
};

export default GlobalChatWidget;
